import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { EntityActions } from 'common/entity/EntityActions';
import { Page } from 'common/components/layout/Page/Page';
import { PasswordForm } from './PasswordForm';
import { UserDetailsForm } from './UserDetailsForm';

interface UserSettingsProps {
  appState: AppState;
  entityActions: EntityActions;
}

interface UserSettingsState {}

export class UserSettings extends React.Component<UserSettingsProps, UserSettingsState> {
  render() {
    return (
      <Page title="Users Settings">
        <div className="row">
          <div className="col">
            <div className="card card-responsive">
              <div className="card-block">
                <UserDetailsForm user={this.props.appState.user!} entityActions={this.props.entityActions} />
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card">
              <div className="card-block">
                <PasswordForm user={this.props.appState.user!} />
              </div>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/UserSettings/UserSettings.tsx